import { useChainId, usePublicClient } from 'wagmi';

export const useMultiCall = () => {
  const chainId = useChainId();
  const c = usePublicClient({
    chainId,
  });

  return c?.multicall;
};
